/**
 * 文件处理工具函数
 */

/**
 * 格式化文件大小为可读字符串
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}

/**
 * 获取文件类型的图标名称（Ant Design 图标）
 */
export function getFileIcon(fileName: string): string {
  const ext = getFileExtension(fileName);
  
  // Excel 文件
  if (['.xlsx', '.xls', '.csv'].includes(ext)) {
    return 'file-excel';
  }
  
  // Word 文件
  if (['.docx', '.doc'].includes(ext)) {
    return 'file-word';
  }
  
  // PDF 文件
  if (ext === '.pdf') {
    return 'file-pdf';
  }
  
  // 压缩包
  if (['.zip', '.rar', '.7z'].includes(ext)) {
    return 'file-zip';
  }
  
  // 图片
  if (['.jpg', '.jpeg', '.png', '.gif'].includes(ext)) {
    return 'file-image';
  }
  
  return 'file';
}

/**
 * 获取文件扩展名（包含点号）
 */
export function getFileExtension(fileName: string): string {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return '';
  }
  return fileName.slice(lastDotIndex).toLowerCase();
}

/**
 * 验证文件类型
 */
export function validateFileType(fileName: string): boolean {
  const allowedExtensions = [
    '.xlsx', '.xls', '.csv',  // Excel
    '.docx', '.doc',          // Word
    '.pdf',                   // PDF
    '.zip', '.rar', '.7z',    // 压缩包
    '.jpg', '.jpeg', '.png'   // 图片
  ];
  
  const ext = getFileExtension(fileName);
  return allowedExtensions.includes(ext);
}

/**
 * 验证文件大小
 */
export function validateFileSize(fileSize: number, maxSize: number = 50 * 1024 * 1024): boolean {
  return fileSize <= maxSize;
}

/**
 * 获取文件类型的颜色（用于标签显示）
 */
export function getFileTypeColor(fileName: string): string {
  const ext = getFileExtension(fileName);
  
  // Excel - 绿色
  if (['.xlsx', '.xls', '.csv'].includes(ext)) {
    return 'green';
  }
  
  // Word - 蓝色
  if (['.docx', '.doc'].includes(ext)) {
    return 'blue';
  }
  
  // PDF - 红色
  if (ext === '.pdf') {
    return 'red';
  }
  
  // 压缩包 - 橙色
  if (['.zip', '.rar', '.7z'].includes(ext)) {
    return 'orange';
  }
  
  // 图片 - 紫色
  if (['.jpg', '.jpeg', '.png', '.gif'].includes(ext)) {
    return 'purple';
  }
  
  return 'default';
}

/**
 * 触发文件下载（备用方法）
 */
export function triggerDownload(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
